import { render, staticRenderFns } from "./PdfTemplatesCreate.vue?vue&type=template&id=6b2979a1"
import script from "./PdfTemplatesCreate.vue?vue&type=script&lang=js"
export * from "./PdfTemplatesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports